import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { useIsMobile } from '@trellis/roots/lib/useIsMobile'
import { useThemeColorMeta } from '@trellis/roots/lib/useThemeColorMeta'
import { lazy, Suspense } from 'react'
import { Toaster } from 'sonner'

import { InstallPromptBanner, IosInstallInstructions } from '@/components/pwa'
import { env } from '@/env'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

const TanStackRouterDevtools =
  import.meta.env.DEV && env.VITE_SHOW_ROUTER_DEVTOOLS
    ? lazy(() =>
        import('@tanstack/react-router-devtools').then((routerDevtools) => ({
          default: routerDevtools.TanStackRouterDevtools,
        })),
      )
    : () => null

function RootLayout() {
  const isMobile = useIsMobile()
  useThemeColorMeta()

  return (
    <>
      <Toaster
        richColors
        position={isMobile ? 'top-center' : 'bottom-right'}
        mobileOffset={{ top: 'calc(env(safe-area-inset-top) + 16px)' }}
      />
      <InstallPromptBanner />
      <IosInstallInstructions />
      <Outlet />
      <Suspense fallback={null}>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  )
}
